// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { formApi } from "api/TenantSlug/Form/api.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import StoreFormRequest = App.Http.Requests.Form.StoreFormRequest;
import GetFormsRequest = App.Http.Requests.Form.GetFormsRequest;
import FormData = App.Data.FormData;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

// Query to get a list of forms
export const useGetFormsQuery = (request: GetFormsRequest, options = {}) => {
    return useQueryApi({
        queryKey: ["getForms", request],
        queryFn: () => formApi.index(request),
        ...options,
    });
};

// Query to get a specific form
export const useGetFormQuery = (formId: string, request, options = {}) => {
    return useQueryApi({
        queryKey: ["getForm", formId, request],
        queryFn: () => formApi.show(formId, request),
        ...options,
    });
};

// Mutation to store a new form
export const useStoreFormMutation = (options = {}) => {
    return useMutationApi({
        mutationKey: ["storeForm"],
        mutationFn: (request: StoreFormRequest) => formApi.store(request),
        ...options,
    });
};

// Mutation to update an existing form
export const useUpdateFormMutation = (formId: string, options = {}) => {
    return useMutationApi({
        mutationKey: ["updateForm", formId],
        mutationFn: (request: StoreFormRequest) => formApi.update(request, formId),
        ...options,
    });
};

// Mutation to destroy a form
export const useDestroyFormMutation = (options = {}) => {
    return useMutationApi({
        mutationKey: ["destroyForm"],
        mutationFn: (form: FormData) => formApi.destroy(form),
        ...options,
    });
};

export const useExportFormsMutation = (
    options: UseMutationOptions<ExportResponse, AxiosError<ApiErrorResponse>, BaseExportRequest> = {}
) => {
    return useMutationApi<ExportResponse, BaseExportRequest>({
        mutationKey: ["exportForms"],
        mutationFn: (request) => formApi.export(request),
        ...options,
    });
};
